<template>
    <div class="unpacking-scan-check">
        <div class="usc-toolbar">
            <b-button size="sm" variant="secondary" @click="goBack">返回</b-button>
            <b-button size="sm" :variant="scannerOpen ? 'info' : 'primary'" @click="toggleScanner">
                <i class="fa fa-qrcode"></i> {{ scannerOpen ? '关闭扫码' : '打开扫码' }}
            </b-button>
            <span class="usc-title">扫码检验</span>
            <div class="usc-right">
                <span class="usc-count">已勾选 {{ selectedIds.length }} 项</span>
                <b-button size="sm" variant="success" :disabled="selectedIds.length === 0" @click="onMatch">账实相符</b-button>
                <b-button size="sm" variant="warning" :disabled="selectedIds.length === 0" @click="onNotMatch">账实不符</b-button>
            </div>
        </div>

        <div class="usc-body">
            <div v-show="scannerOpen" class="usc-scanner">
                <transition name="usc-status-slide">
                    <div v-if="statusMsg" :key="statusKey" class="usc-status"
                         :class="`usc-status--${statusType}`">
                        {{ statusMsg }}
                    </div>
                </transition>
                <qr-code-scanner ref="scanner" continuous @getCodeData="onScan"></qr-code-scanner>
            </div>
            <div class="usc-table">
                <mini-table :key="tableKey"
                            ref="miniTable"
                            headerTitle=""
                            disable-header
                            read-only
                            enable-row-check
                            row-click-check
                            effect-origin-row
                            row-key="id"
                            :fields="fields"
                            :items="tableData"
                            @rowChecked="onChecked">
                </mini-table>
            </div>
        </div>

        <el-dialog :visible.sync="reasonDialogVisible" :close-on-click-modal="false" title="账实不符原因"
                   width="90%" append-to-body>
            <el-input v-model="notMatchReason" type="textarea" :rows="4"
                      placeholder="请输入账实不符原因（所有勾选条目共用）"></el-input>
            <div slot="footer" class="dialog-footer">
                <b-button variant="secondary" @click="reasonDialogVisible = false">取消</b-button>
                <b-button variant="primary" @click="confirmNotMatch">保存</b-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesInventoryUnpackingScanCheckView",
    components: {qrCodeScanner, MiniTable},
    mixins: [emCommonApiMixin],
    data() {
        return {
            scannerOpen: false,
            pendingRows: [],
            selectedIds: [],
            reasonDialogVisible: false,
            notMatchReason: '',
            tableKey: 0,
            highlightId: null,
            statusMsg: '',
            statusType: 'success',
            statusTimer: null,
            statusKey: 0,
            fields: [
                {key: 'projectCode', label: '项目号'},
                {key: 'deliveryCode', label: '发货码'},
                {key: 'quantity', label: '数量', thStyle: {width: '64px'}},
                {key: 'unit', label: '单位', thStyle: {width: '56px'}},
                {key: 'materialCode', label: '物料号'},
                {key: 'materialDesc', label: '转交物料中文描述'},
                {key: 'cid', label: 'CID', thStyle: {width: '70px'}},
            ],
        };
    },
    computed: {
        tableData() {
            return this.pendingRows;
        },
    },
    mounted() {
        this.$store.commit("base/setShowHeader", false, {root: true});
        this.$store.commit("base/setShowSidebar", false, {root: true});
        this.openScanner();
    },
    beforeRouteLeave(to, from, next) {
        if (this.statusTimer) {
            clearTimeout(this.statusTimer);
            this.statusTimer = null;
        }
        if (this.scannerOpen && this.$refs.scanner) {
            this.$refs.scanner.closeCamera();
        }
        this.$store.commit("base/setShowHeader", true, {root: true});
        this.$store.commit("base/setShowSidebar", true, {root: true});
        next();
    },
    methods: {
        entityApi() {
            return this.$_emApiMixin_entityBaseApi("sithMesInventoryPackageMaterial");
        },
        goBack() {
            this.$router.back();
        },
        toggleScanner() {
            if (this.scannerOpen) {
                this.$refs.scanner.closeCamera();
                this.$refs.scanner.resetOutputData();
                this.scannerOpen = false;
                this.clearHighlight();
            } else {
                this.openScanner();
            }
        },
        openScanner() {
            this.scannerOpen = true;
            this.$nextTick(() => setTimeout(() => {
                if (this.scannerOpen && this.$refs.scanner) {
                    this.$refs.scanner.openCamera('');
                }
            }, 300));
        },
        onScan(data) {
            // 任一次新的扫码尝试，先清除上一行的高亮
            this.clearHighlight();
            let deliveryCode;
            try {
                const obj = JSON.parse(data);
                deliveryCode = obj['发货码'];
            } catch (e) {
                this.showStatus('error', "无效的二维码");
                return;
            }
            if (!deliveryCode) {
                this.showStatus('error', "二维码中缺少发货码");
                return;
            }
            const url = `${this.entityApi()}/findMaterialByDeliveryCode?deliveryCode=${encodeURIComponent(deliveryCode)}`;
            this.$_emApiMixin_get(url, {}).then((value) => {
                if (!value || !value.id) {
                    this.showStatus('error', `无对应物料或物料已开箱检验 发货码:${deliveryCode}`);
                    return;
                }
                const exists = this.pendingRows.some(r => r.id === value.id);
                if (exists) {
                    this.showStatus('warning', `已在列表中 ${this.formatRowInfo(value)}`);
                    this.setHighlight(value.id, 'warning');
                    this.scrollToRow(value.id);
                    return;
                }
                value.__status = 'pending';
                value._rowVariant = null;
                this.pendingRows.push(value);
                this.setHighlight(value.id, 'success');
                this.scrollToRow(value.id);
                this.showStatus('success', `扫码成功 ${this.formatRowInfo(value)}`);
            });
        },
        showStatus(type, msg) {
            this.statusType = type;
            this.statusMsg = msg;
            this.statusKey++;
            if (this.statusTimer) {
                clearTimeout(this.statusTimer);
            }
            this.statusTimer = setTimeout(() => {
                this.statusMsg = '';
                this.statusTimer = null;
            }, 3000);
        },
        formatRowInfo(obj) {
            const parts = [];
            if (obj.deliveryCode) {
                parts.push(`发货码:${obj.deliveryCode}`);
            }
            if (obj.materialCode) {
                parts.push(`物料号:${obj.materialCode}`);
            }
            if (obj.quantity != null) {
                parts.push(`数量:${obj.quantity}${obj.unit || ''}`);
            }
            return `${obj.deliveryCode}-${obj.materialCode}-${obj.quantity} ${obj.unit || ''}`;
        },
        findRow(id) {
            return this.pendingRows.find(r => r.id === id);
        },
        setHighlight(id, variant) {
            this.clearHighlight();
            const row = this.findRow(id);
            if (row) {
                row._rowVariant = variant;
                this.highlightId = id;
            }
        },
        clearHighlight() {
            if (this.highlightId == null) {
                return;
            }
            const row = this.findRow(this.highlightId);
            if (row) {
                row._rowVariant = null;
            }
            this.highlightId = null;
        },
        scrollToRow(id) {
            const attempt = (tries) => {
                const idx = this.tableData.findIndex(r => r.id === id);
                const root = this.$refs.miniTable && this.$refs.miniTable.$el;
                if (idx < 0 || !root) {
                    return;
                }
                const rows = root.querySelectorAll('tbody > tr');
                const el = rows[idx];
                if (el) {
                    const container = this.getScrollParent(el);
                    if (container) {
                        const cRect = container.getBoundingClientRect();
                        const eRect = el.getBoundingClientRect();
                        // 将目标行滚动到容器中部，兼顾向上/向下且避开粘性表头
                        let top = container.scrollTop + (eRect.top - cRect.top)
                                - (container.clientHeight - eRect.height) / 2;
                        top = Math.max(0, top);
                        container.scrollTo({top, behavior: 'smooth'});
                    } else {
                        el.scrollIntoView({behavior: 'smooth', block: 'center'});
                    }
                    return;
                }
                // 行还未渲染完成时重试，避免滚动失效
                if (tries > 0) {
                    requestAnimationFrame(() => attempt(tries - 1));
                }
            };
            this.$nextTick(() => requestAnimationFrame(() => attempt(12)));
        },
        getScrollParent(node) {
            let el = node.parentElement;
            while (el) {
                const style = window.getComputedStyle(el);
                const oy = style.overflowY;
                if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) {
                    return el;
                }
                el = el.parentElement;
            }
            return null;
        },
        onChecked(ids) {
            // 改变行勾选后取消高亮
            this.clearHighlight();
            this.selectedIds = ids.filter(id => this.pendingRows.some(r => r.id === id));
        },
        onMatch() {
            if (this.selectedIds.length === 0) {
                this.$message.warning("请先勾选条目");
                return;
            }
            this.$confirm(`确认将选中 ${this.selectedIds.length} 项标记为账实相符并保存？`, "保存确认", {type: 'warning'})
                    .then(() => this.saveCheck(true, ''))
                    .catch(() => {
                    });
        },
        onNotMatch() {
            if (this.selectedIds.length === 0) {
                this.$message.warning("请先勾选条目");
                return;
            }
            this.notMatchReason = '';
            this.reasonDialogVisible = true;
        },
        confirmNotMatch() {
            if (!this.notMatchReason || this.notMatchReason.trim() === '') {
                this.$message.error("请填写账实不符原因");
                return;
            }
            this.reasonDialogVisible = false;
            this.saveCheck(false, this.notMatchReason.trim());
        },
        saveCheck(match, reason) {
            const ids = this.selectedIds.slice();
            const url = `${this.entityApi()}/manualCheck?ids=${ids.join(',')}`
                    + `&accountMatchActualSituationOrNot=${match}`
                    + `&notMatchReason=${encodeURIComponent(reason)}`;
            this.$_emApiMixin_post(url, {}).then((response) => {
                if (response.status === 200) {
                    this.removeConfirmedRows(ids);
                    this.$message.success("检验完成");
                } else {
                    this.$message.error("检验失败");
                }
            });
        },
        removeConfirmedRows(ids) {
            this.clearHighlight();
            this.pendingRows = this.pendingRows.filter(r => ids.indexOf(r.id) === -1);
            this.selectedIds = [];
            // 重建表格以重置 MiniTable 内部勾选状态
            this.tableKey++;
        },
    },
};
</script>
<style lang="scss" scoped>
.unpacking-scan-check {
    display: flex;
    flex-direction: column;
    height: 100vh;
    box-sizing: border-box;
    padding: 8px;
    background: #f5f6f8;
}

.usc-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #fff;
    border-radius: 6px;
    flex-wrap: wrap;
    gap: 8px;
}

.usc-title {
    font-size: 16px;
    font-weight: bold;
}

.usc-right {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.usc-count {
    font-size: 13px;
    color: #666;
}

.usc-body {
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    min-height: 0;
}

.usc-scanner {
    position: relative;
    width: 340px;
    flex-shrink: 0;
    margin-right: 8px;
    background: #eef2f7;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.usc-status {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    padding: 5px 10px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    line-height: 1.3;
    word-break: break-all;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(2px);
}

.usc-status--success {
    background: rgba(103, 194, 58, 0.5);
}

.usc-status--error {
    background: rgba(245, 108, 108, 0.5);
}

.usc-status--warning {
    background: rgba(230, 162, 60, 0.5);
}

.usc-status-slide-enter-active {
    transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease;
}

.usc-status-slide-leave-active {
    transition: transform 0.3s cubic-bezier(0.55, 0, 1, 0.45), opacity 0.3s ease;
}

.usc-status-slide-enter,
.usc-status-slide-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}

.usc-table {
    flex: 1;
    min-width: 0;
    background: #fff;
    border-radius: 6px;
    padding: 6px;
    overflow: hidden;
    display: flex;
}

@media (orientation: portrait) {
    .usc-body {
        flex-direction: column;
    }

    .usc-scanner {
        width: 100%;
        height: 240px;
        margin-right: 0;
        margin-bottom: 8px;
    }
}

/* 让 MiniTable 铺满容器，单元格最小宽度 60px，总宽超出容器时横向滚动 */
.usc-table ::v-deep #table {
    height: 100%;
}

.usc-table ::v-deep thead th:hover {
    resize: none !important;
}

.usc-table ::v-deep thead th,
.usc-table ::v-deep tbody td {
    min-width: 60px;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.usc-table ::v-deep tbody td * {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.usc-table ::v-deep tbody td .d-flex {
    min-width: 0;
    flex-wrap: wrap;
}

/* 勾选列(第1列)与行号列(第2列)固定 20px 宽 */
.usc-table ::v-deep thead th:nth-child(1),
.usc-table ::v-deep tbody td:nth-child(1),
.usc-table ::v-deep thead th:nth-child(2),
.usc-table ::v-deep tbody td:nth-child(2) {
    width: 25px !important;
    min-width: 25px !important;
    max-width: max-content !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
    text-align: center;
}
</style>
